import React from 'react';
import { CaptionStyle, SpecialEffect } from '../../../types'; // adjust path as needed

interface CaptionStylePresetsProps {
  segment: { style: CaptionStyle };
  updateStyle: (newStyle: CaptionStyle) => void;
}

// Define 25 preset caption styles.
const presetStyles: CaptionStyle[] = [
  { fontSize: 33, color: '#ffffff', stroke: '#000000', strokeWidth: 2, fontFamily: 'Alfa Slab One', shadowColor: '#000000', shadowxz: 0, specialEffect: SpecialEffect.ZOOMOUT, yPosition: 20 },
  { fontSize: 40, color: 'white', stroke: '#8254ad', strokeWidth: 2, fontFamily: 'Lilita One', shadowColor: '#000000', shadowxz: 0, specialEffect: SpecialEffect.ZOOMOUT, yPosition: 20 },
  { fontSize: 33, color: '#ffff00', stroke: '#000000', strokeWidth: 0, fontFamily: 'Bebas Neue', shadowColor: '#000000', shadowxz: 2, specialEffect: SpecialEffect.FADEOUT, yPosition: 20 },
  { fontSize: 33, color: '#ff6347', stroke: '#333333', strokeWidth: 1, fontFamily: 'Anton', shadowColor: '#222222', shadowxz: 3, specialEffect: SpecialEffect.ZOOMOUT, yPosition: 20 },
  { fontSize: 33, color: '#00ff00', stroke: '#000000', strokeWidth: 0, fontFamily: 'Lilita One', shadowColor: '#444444', shadowxz: 2, specialEffect: SpecialEffect.FADEOUT, yPosition: 20 },
  { fontSize: 33, color: '#ffffff', stroke: '#000000', strokeWidth: 0, fontFamily: 'Alfa Slab One', shadowColor: '#000000', shadowxz: 2, specialEffect: SpecialEffect.ZOOMOUT, yPosition: 20 },
  { fontSize: 23, color: '#ff00ff', stroke: '#111111', strokeWidth: 1, fontFamily: 'Rubik Mono One', shadowColor: '#000000', shadowxz: 2, specialEffect: SpecialEffect.FADEOUT, yPosition: 20 },
  { fontSize: 33, color: '#00ffff', stroke: '#222222', strokeWidth: 1, fontFamily: 'Passion One', shadowColor: '#000000', shadowxz: 3, specialEffect: SpecialEffect.ZOOMOUT, yPosition: 20 },
  { fontSize: 33, color: '#ffd700', stroke: '#333333', strokeWidth: 1, fontFamily: 'Concert One', shadowColor: '#444444', shadowxz: 2, specialEffect: SpecialEffect.FADEOUT, yPosition: 20 },
  { fontSize: 33, color: '#ff1493', stroke: '#555555', strokeWidth: 1, fontFamily: 'Luckiest Guy', shadowColor: '#000000', shadowxz: 2, specialEffect: SpecialEffect.ZOOMOUT, yPosition: 20 },
  { fontSize: 33, color: '#32cd32', stroke: '#000000', strokeWidth: 0, fontFamily: 'Titan One', shadowColor: '#000000', shadowxz: 2, specialEffect: SpecialEffect.FADEOUT, yPosition: 20 },
  { fontSize: 33, color: '#ffa500', stroke: '#333333', strokeWidth: 1, fontFamily: 'Paytone One', shadowColor: '#000000', shadowxz: 2, specialEffect: SpecialEffect.ZOOMOUT, yPosition: 20 },
  { fontSize: 33, color: '#87ceeb', stroke: '#111111', strokeWidth: 0, fontFamily: 'Crete Round', shadowColor: '#222222', shadowxz: 2, specialEffect: SpecialEffect.FADEOUT, yPosition: 20 },
  { fontSize: 33, color: '#00ced1', stroke: '#222222', strokeWidth: 1, fontFamily: 'Bangers', shadowColor: '#000000', shadowxz: 3, specialEffect: SpecialEffect.ZOOMOUT, yPosition: 20 },
  { fontSize: 33, color: '#ff4500', stroke: '#333333', strokeWidth: 1, fontFamily: 'Atma', shadowColor: '#444444', shadowxz: 2, specialEffect: SpecialEffect.FADEOUT, yPosition: 20 },
  { fontSize: 33, color: '#adff2f', stroke: '#000000', strokeWidth: 0, fontFamily: 'Chewy', shadowColor: '#000000', shadowxz: 2, specialEffect: SpecialEffect.ZOOMOUT, yPosition: 20 },
  { fontSize: 33, color: '#ff69b4', stroke: '#555555', strokeWidth: 1, fontFamily: 'Chicle', shadowColor: '#222222', shadowxz: 3, specialEffect: SpecialEffect.FADEOUT, yPosition: 20 },
  { fontSize: 33, color: '#8a2be2', stroke: '#444444', strokeWidth: 0, fontFamily: 'Ranchers', shadowColor: '#000000', shadowxz: 2, specialEffect: SpecialEffect.ZOOMOUT, yPosition: 20 },
  { fontSize: 27, color: '#ffdead', stroke: '#333333', strokeWidth: 1, fontFamily: 'Peralta', shadowColor: '#000000', shadowxz: 2, specialEffect: SpecialEffect.FADEOUT, yPosition: 20 },
  { fontSize: 33, color: '#dda0dd', stroke: '#222222', strokeWidth: 0, fontFamily: 'Original Surfer', shadowColor: '#000000', shadowxz: 2, specialEffect: SpecialEffect.ZOOMOUT, yPosition: 20 },
  { fontSize: 33, color: '#b0c4de', stroke: '#111111', strokeWidth: 0, fontFamily: 'Poetsen One', shadowColor: '#000000', shadowxz: 2, specialEffect: SpecialEffect.FADEOUT, yPosition: 20 },
  { fontSize: 33, color: '#ffa07a', stroke: '#333333', strokeWidth: 1, fontFamily: 'Bebas Neue', shadowColor: '#222222', shadowxz: 2, specialEffect: SpecialEffect.ZOOMOUT, yPosition: 20 },
  { fontSize: 33, color: '#90ee90', stroke: '#444444', strokeWidth: 0, fontFamily: 'Anton', shadowColor: '#000000', shadowxz: 2, specialEffect: SpecialEffect.FADEOUT, yPosition: 20 },
  { fontSize: 33, color: '#ffb6c1', stroke: '#555555', strokeWidth: 1, fontFamily: 'Lilita One', shadowColor: '#222222', shadowxz: 3, specialEffect: SpecialEffect.ZOOMOUT, yPosition: 20 },
  { fontSize: 33, color: '#98fb98', stroke: '#000000', strokeWidth: 0, fontFamily: 'Alfa Slab One', shadowColor: '#444444', shadowxz: 2, specialEffect: SpecialEffect.FADEOUT, yPosition: 20 },
  { fontSize: 23, color: '#87cefa', stroke: '#333333', strokeWidth: 1, fontFamily: 'Rubik Mono One', shadowColor: '#000000', shadowxz: 2, specialEffect: SpecialEffect.ZOOMOUT, yPosition: 20 },
  { fontSize: 33, color: '#ff1493', stroke: '#222222', strokeWidth: 1, fontFamily: 'Passion One', shadowColor: '#000000', shadowxz: 2, specialEffect: SpecialEffect.FADEOUT, yPosition: 20 }
];

const CaptionStylePresets: React.FC<CaptionStylePresetsProps> = ({
  segment,
  updateStyle,
}) => {
  // When a preset is selected, update the segment's style with the preset values.
  const handleClick = (preset: CaptionStyle) => {
    updateStyle(preset);
  };

  return (
    <div
        style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: '8px',
      }}
    >
      {presetStyles.map((preset, index) => {
        // Determine the label text based on the specialEffect (example: kids mood for fade-out, professional for zoom-out)
        const labelText = preset.specialEffect === 'fade-out' ? 'Kids Mood' : 'Professional';
        // A sample text for preview, you can adjust it as needed.
        const sampleText = "Sample";
        return (
          <button
            key={index}
            onClick={() => handleClick(preset)}
            style={{
              color: preset.color,
              backgroundColor: '#333',
              border:
                (segment.style.fontFamily === preset.fontFamily)&& (segment.style.color === preset.color) && (segment.style.shadowxz === preset.shadowxz) ? '2px solid #2196f3' : '1px solid #555',
              padding: '8px',
              borderRadius: '4px',
              cursor: 'pointer',
              textAlign: 'center',
              fontFamily: preset.fontFamily,
              fontSize: '14px',
              boxShadow: `2px 2px 4px ${preset.shadowColor}`,
            }}
            title={`Font: ${preset.fontFamily}, Effect: ${preset.specialEffect}`}
          >
            {preset.fontFamily} <br />
            {/* <small>{labelText}</small> */}
          </button>
        );
      })}
    </div>
  );
};

export default CaptionStylePresets;
